import { Component, Input, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-page-analytic',
  templateUrl: './page-analytic.component.html',
  styleUrls: ['./page-analytic.component.scss']
})
export class PageAnalytic implements OnInit {

  @Input() dataReport: any
  title_report = 'HIỆU QUẢ HÌNH THỨC BÀI ĐĂNG TRÊN FANPAGE THƯƠNG HIỆU';

  public bubbleChartOptions = {
    responsive: true,
    scales: {
      xAxes: [
        {
          ticks: {
            min: 0,
            max: 500
          }
        }
      ],
      yAxes: [
        {
          ticks: {
            min: 0,
            max: 100
          }
        }
      ]
    }
  };
    public bubbleChartColors = [
    { backgroundColor: '#00b0f0' },
    { backgroundColor: '#c10e45' },
    { backgroundColor: '#04AA6D' }
  ]
  public bubbleChartType = 'bubble';
  public bubbleChartLegend = true;

  public bubbleChartData = [];




  linkCount = 0;
  linkInteractiveCount  = 0;

  videoCount = 0;
  videoInteractiveCount  = 0;

  photoCount  = 0;
  photoInteractiveCount  = 0;

  htmlRight : ''


  constructor() {
    console.log(this.dataReport)
  }

  ngOnInit(): void {
  };
  ngOnChanges(changes: SimpleChanges) {
    console.log(this.dataReport)
    this.mappingData()
    // changes.prop contains the old and the new value...
  }
  mappingData() {
    if(this.dataReport && this.dataReport.data) {
      if(this.dataReport.report_title) {
        this.title_report = this.dataReport.report_title;
      }

      this.videoCount = this.dataReport.data.videoCount;
      this.videoInteractiveCount = this.dataReport.data.videoInteractiveCount;
      
      this.photoCount = this.dataReport.data.photoCount;
      this.photoInteractiveCount = this.dataReport.data.photoInteractiveCount;

      this.linkCount = this.dataReport.data.linkCount;
      this.linkInteractiveCount = this.dataReport.data.linkInteractiveCount;

      this.bubbleChartData = [
        {
          data: [{ x: this.photoInteractiveCount || 0, y: this.photoCount, r: this.photoCount   }],
          label: 'Photo'
        },
        {
          data: [{ x: this.videoInteractiveCount || 0, y: this.videoCount, r: this.videoCount  }],
          label: 'Video'
        },
         {
          data:[{ x: this.linkInteractiveCount, y: this.linkCount, r:  this.linkCount  }],
          label: 'Link'
        }
      ];

      this.bubbleChartOptions = {
        responsive: true,
        scales: {
          xAxes: [
            {
              ticks: {
                min: 0,
                max: this.videoInteractiveCount > this.photoInteractiveCount ? Math.round(this.videoInteractiveCount * 1.3) : this.photoInteractiveCount > 0 ?  Math.round(this.photoInteractiveCount* 1.3) : 1000
              }
            }
          ],
          yAxes: [
            {
              ticks: {
                min: 0,
                max: this.videoCount > this.photoCount ? this.videoCount * 1.5 : this.photoCount > 0?  this.photoCount *1.5 : 10
              }
            }
          ]
        }
      };

      this.htmlRight = this.dataReport.data.htmlRight;
    
 
    }
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-component/page-analytic/page-analytic.component.ts